import Modal from "components/common/Modal";
import React, { FC, useState } from "react";
import { FaRegCopy } from "react-icons/fa";

interface ModalProps {
  isOpen: boolean;
  onClose: any;
  mailDetails: {
    to: string;
    bodyHtml: string;
  };
}

const MailCopyModal: FC<ModalProps> = ({ isOpen, onClose, mailDetails }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = () => {
    if (mailDetails?.bodyHtml) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = mailDetails.bodyHtml;
      const plainText = tempElement.innerText;

      navigator.clipboard.writeText(plainText).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2s
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full md:w-[70%] lg:w-[50%] max-h-[90%]" headerClassName="bg-[#F0F4FD] -my-5 py-5" header={<p className="px-2 md:px-5 font-extrabold text-sm md:text-base">Please copy and paste the text below to email your insurance company: {mailDetails?.to} from your registered email id.</p>}>
      <p dangerouslySetInnerHTML={{ __html: mailDetails?.bodyHtml }} className="px-5 py-5 mt-5 text-sm font-semibold overflow-y-scroll max-h-96"></p>

      <div className="flex justify-center py-5 gap-2 items-center cursor-pointer bg-[#F0F4FD]" onClick={handleCopyToClipboard}>
        <FaRegCopy />
        <p>{copied ? "Copied!" : "Copy to Clipboard"}</p>
      </div>
    </Modal>
  );
};

export default MailCopyModal;
